var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-item-picker",class:{ 'is-active': _vm.isActive },on:{"click":_vm.onClick}},[_c('TextAlignLeftSvg')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }